<template>
  <div class="product-section-nav h-max md:sticky md:top-0 md:bg-gray-100">
    <ul class="flex justify-evenly gap-5 flex-wrap md:flex-col">
      <li class="bg-gray-100 py-2 px-4 md:p-0 rounded">
        <a @click="scrollTo('product-overview')">OVERVIEW</a>
      </li>
      <li class="bg-gray-100 py-2 px-4 md:p-0 rounded">
        <a @click="scrollTo('product-specifications')">SPECIFICATIONS</a>
      </li>

      <!-- <li class="bg-gray-100 py-2 px-4 md:p-0 rounded">
        <a @click="scrollTo('product-technical-drawing')">TECHNICAL DRAWING</a>
      </li> -->

      <li class="bg-gray-100 py-2 px-4 md:p-0 rounded">
        <a @click="scrollTo('product-video')">VIDEO</a>
      </li>
      <!-- <li class="bg-gray-100 py-2 px-4 md:p-0 rounded">
        <a @click="scrollTo('product-model')">3D MODEL</a>
      </li> -->
      <!-- <li class="bg-gray-100 py-2 px-4 md:p-0 rounded">
        <a @click="scrollTo('product-application')">APPLICATION</a>
      </li> -->
      <li class="bg-gray-100 py-2 px-4 md:p-0 rounded">
        <a @click="scrollTo('product-attachments')">ATTACHMENTS</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ProductSectionNav",
  methods: {
    scrollTo(refName) {
      const scrollTo = document.getElementById(refName);
      scrollTo.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style>
.product-section-nav {
  @apply md:p-5;
  font-weight: 600;
}
</style>
<style scoped>
li {
  @apply md:my-1;
}

li a:hover {
  color: var(--rofix-primary);
}
</style>
